import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadSonic = () => {
    const promiseSonic = new Promise((resolve, reject) => {
        loader.load(
            "office/model/sonic/sonic.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                model.position.set(-2.1926206459135757, 2.761932129544873, 9.892049205860353);
                model.scale.set(0.19, 0.19, 0.19);
                model.rotation.set(-3.141592653589793, 0.03982414230743072, -3.141592653589793);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseSonic;
};

export { loadSonic };
